/** Modos de visualizações da aplicação */
export interface VisualizacaoModo {
    id: number;
    nome: string;
    iconClass?: string;
}

export const visualizacaoModoList: VisualizacaoModo = {id: 1, nome: 'Lista', iconClass: 'fas fa-bars'};
export const visualizacaoModoPipeline: VisualizacaoModo = {id: 2, nome: 'Pipeline', iconClass: 'fas fa-th'};
export const visualizacaoModoDashboard: VisualizacaoModo = {id: 3, nome: 'Dashboard', iconClass: 'fas fa-tachometer-alt'};
export const visualizacaoModoResumo: VisualizacaoModo = {id: 4, nome: 'Resumo', iconClass: 'far fa-clipboard'};
export const visualizacaoModoCalendar: VisualizacaoModo = {id: 5, nome: 'Calendário', iconClass: 'far fa-calendar-alt'};

export const visualizacaoModos: VisualizacaoModo[] = [
    visualizacaoModoList,
    visualizacaoModoPipeline,
    visualizacaoModoDashboard,
    visualizacaoModoResumo,
    visualizacaoModoCalendar
];

/** Verifica se o modo de visualização informado é List */
export function isVisualizacaoModoList(modo: number): boolean {
    return modo === visualizacaoModoList.id;
}

/** Verifica se o modo de visualização informado é Pipeline */
export function isVisualizacaoModoPipeline(modo: number): boolean {
    return modo === visualizacaoModoPipeline.id;
}

/** Verifica se o modo de visualização informado é Dashboard */
export function isVisualizacaoModoDashboard(modo: number): boolean {
    return modo === visualizacaoModoDashboard.id;
}

/** Verifica se o modo de visualização informado é Resumo */
export function isVisualizacaoModoResumo(modo: number): boolean {
    return modo === visualizacaoModoResumo.id;
}

/** Verifica se o modo de visualização informado é Calendar */
export function isVisualizacaoModoCalendar(modo: number): boolean {
    return modo === visualizacaoModoCalendar.id;
}
